export const BuefyTypes = {
  SUCCESS: "is-success",
  WARNING: "is-warning",
  DANGER: "is-danger",
};
